import React from 'react';

import { motion } from 'framer-motion';
import { AlertCircle, Clock, MessageCircle, Phone } from 'lucide-react';

import ModernButton from './ui/ModernButton';

const EmergencyContact: React.FC = () => {
  const handleWhatsAppClick = (isEmergency: boolean) => {
    const baseMessage = isEmergency
      ? '🚨 *Contacto de Emergencia*\n\nHola, necesito ayuda urgente con mi proyecto.\n\n*Detalles de la emergencia:*\n- Requiero respuesta inmediata\n- Disponibilidad 24/7\n- Tiempo de respuesta garantizado: 30 minutos'
      : '👋 *Contacto Regular*\n\nHola, me gustaría obtener información sobre sus servicios.\n\n*Me interesa conocer:*\n- Detalles de servicios\n- Costos aproximados\n- Tiempos de implementación';

    const encodedMessage = encodeURIComponent(baseMessage);
    window.open(`https://wa.me/56984918725?text=${encodedMessage}`, '_blank');
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-gradient-to-r from-red-50 to-orange-50 rounded-xl shadow-lg p-6 border border-red-100"
    >
      <div className="flex items-start space-x-4">
        <div className="bg-red-100 p-3 rounded-full">
          <AlertCircle className="h-6 w-6 text-red-600" />
        </div>
        <div className="flex-1">
          <h2 className="text-2xl font-bold text-red-700 mb-2">Proyectos Urgentes</h2>
          <p className="text-gray-700 mb-4">
            Para proyectos con fechas críticas o emergencias, contáctanos directamente por WhatsApp.
            Respuesta garantizada en menos de 30 minutos.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div className="flex items-center space-x-3 bg-white bg-opacity-50 p-3 rounded-lg">
              <Phone className="h-5 w-5 text-red-600" />
              <span className="font-medium">+56 9 8491 8725</span>
            </div>
            <div className="flex items-center space-x-3 bg-white bg-opacity-50 p-3 rounded-lg">
              <Clock className="h-5 w-5 text-red-600" />
              <span className="font-medium">24/7 Disponible</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <ModernButton
              variant="accent"
              size="lg"
              className="flex-1 bg-red-600 hover:bg-red-700 text-white shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center"
              onClick={() => handleWhatsAppClick(true)}
            >
              <AlertCircle className="h-5 w-5 mr-2" />
              Contacto de Emergencia
            </ModernButton>

            <ModernButton
              variant="primary"
              size="lg"
              className="flex-1 bg-white hover:bg-blue-50 text-blue-600 border-2 border-blue-200 shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center"
              onClick={() => handleWhatsAppClick(false)}
            >
              <MessageCircle className="h-5 w-5 mr-2" />
              Contacto Regular
            </ModernButton>
          </div>

          <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
            <div className="bg-red-50 p-3 rounded-lg">
              <p className="text-red-700 font-medium">⚡ Emergencia:</p>
              <p className="text-gray-600">Respuesta en 30 min</p>
            </div>
            <div className="bg-blue-50 p-3 rounded-lg">
              <p className="text-blue-700 font-medium">📅 Regular:</p>
              <p className="text-gray-600">Respuesta en 24h</p>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default EmergencyContact;
